<template>
  <v-row>
    <v-col>
      <router-view name="default" lazy></router-view>
      <router-view name="view" lazy></router-view>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {},
  props: {},
  components: {},
};
</script>

<style scoped></style>
